module.exports = __webpack_public_path__ + "static/media/dollar-2-beenleigh.f65c859d.png";